import { Route } from '@angular/router';
import { AttributeEditComponent } from 'src/app/pages/datasets/attribute-edit/attribute-edit.component';
import { AttributesComponent } from 'src/app/pages/datasets/attributes/attributes.component';
import { RoutingID } from '../../../../sb-routing-enum';
import { SbIcons } from '@ngx-seatback/icons';

export const attributes: Route = {
  path: 'attributes',
  title: 'nav.datasets.attributes',
  data: {
    icon: SbIcons.attributes,
    breadcrumb: 'nav.datasets.attributes',
    id: RoutingID.attributes,
  },
  children: [
    {
      path: '',
      component: AttributesComponent,
      data: {
        breadcrumb: '',
      },
    },
    {
      path: 'attribute-edit/:attributeID',
      title: 'nav.datasets.attributes.edit',
      data: {
        icon: SbIcons.edit,
        breadcrumb: 'nav.datasets.attributes.edit',
        id: RoutingID.attributeEdit,
      },
      children: [
        {
          path: '',
          component: AttributeEditComponent,
          data: {
            breadcrumb: '',
          },
        },
      ],
    },
    {
      path: 'attribute-create',
      title: 'nav.datasets.attributes.create',
      data: {
        icon: SbIcons.plus,
        breadcrumb: 'nav.datasets.attributes.create',
        id: RoutingID.attributeCreate,
      },
      children: [
        {
          path: '',
          component: AttributeEditComponent,
          data: {
            breadcrumb: '',
          },
        },
      ],
    },
  ],
};
